/*
 * Model class User
 */
export default class User {
    constructor($http) {
        this.http = $http;
    }

	getUserDetails() {
		return new Promise((resolve, reject)=> {
			resolve('This is coming from the user class get.');
		});
	}

	login(data) {
		return new Promise((resolve, reject)=> {
            $.post('/user/loginpost', data, function(data){
                resolve(data);
            });
		});
	}

	checkMembership(data) {
        return new Promise((resolve, reject)=>{
           $.post('/user/check_membership', data, function(data){
               resolve(data);
           });
        });
    }

    register(data) {
        return new Promise((resolve, reject)=> {
            $.post('/user/registerpost', data, function(data){
				resolve(data);
			});
        });
    }

    forgotPassword(data) {
        return new Promise((resolve, reject)=>{
            $.post('/user/forgot-password', data, function(data){
                resolve(data);
            });
        });
    }

    resetPassword(data, url) {
        return new Promise((resolve, reject)=>{
            $.post(url, data, function(data){
                resolve(data);
            });
        });
    }

    setGuestPassword(data, url)
    {
        return new Promise((resolve, reject)=>{
            $.post(url, data, function(data){
                resolve(data);
            });
        });
    }

    updateProfile(data) {
        return new Promise((resolve, reject)=>{
            $.post('/user/my-account/update-profile', data, function(data){
                resolve(data);
            });
        });
    }

    changePassword(data) {
        return new Promise((resolve, reject)=>{
            $.post('/user/change-password-post', data, function(data){
                resolve(data);
            });
        });
    }

    samlAcceptTerms(data) {
        return new Promise((resolve, reject)=> {
            $.post('/user/saml/policy-accepted', data, function(data){
                resolve(data);
            });
        });
    }

	logout() {
		return new Promise((resolve, reject)=> {

		});
	}
}
